var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"auto_start":false,"table_store":"core/prices/table"}})}
var staticRenderFns = []

export { render, staticRenderFns }